import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiCall_domain } from "../../api";
import { Rating } from "react-simple-star-rating";
import CommentView from "../CommentView";
import CommentProduct from "../CommentProduct";
import Spinner from "../../Spinner/Spinner";

const VendorDetails = ({ vendorId, ticketHandler }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const headers = {
    Authorization: localStorage.getItem("Api_key"),
    "content-type": "application/json",
  };
  useEffect(() => {
    axios
      .get(`${apiCall_domain}/customer/vendors/${vendorId}`, {
        headers: headers,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      });
  }, []);
  const showHandler = () => {
    setShowMore(!showMore);
  };
  return !loading ? (
    <div className="vendorPageDetails">
      <div className="vendorDetails">
        <img src={data.pic} alt="vendorPage" className="vendorPic" />
        <div className="headSuitableCars" onClick={showHandler}>
          {!showMore ? (
            <p>{data.details.slice(0, 60)}</p>
          ) : (
            <p>{data.details}</p>
          )}
          <i className={"icon-chevron-down"} />
        </div>
      </div>
      <div className="sendTicket" onClick={ticketHandler}>
        <span>همین حالا با فروشگاه مورد نظرت ارتباط برقرار کن</span>
        <span>ارتباط مستقیم با فروشنده</span>
      </div>
      <div className="vendorRatings">
        <h2>{data.store_name}</h2>
        <div className="VendorCity">
          <span>
            محل تامین کننده: <h4>{data.city}</h4>
          </span>
          <span>عملکرد : خیلی خوب</span>
        </div>
        <div>
          <span className="memberance">
            <span>عضویت :</span> <span>{data.join_time}</span>
          </span>
          <div className="score">
            <div className="avgRate">
              <span>{data.rate}</span>
              <img src="/public/assets/pic.svg" alt="pic" />
            </div>
            <div className="ScoreComment">
              <span className="Text">{data.comments.length} دیدگاه</span>
              <span>برای این فروشنده ثبت شده </span>
            </div>
          </div>
        </div>
      </div>
      <div className="vendorP1 vendorP2">
        <div className="KacharsRate">
          <span className="titleRate">رتبه کاچار به فروشنده</span>
          <span className="ratingStar">
            <Rating ratingValue={data.system_rate * 10} readonly={true} />
          </span>
        </div>
        <div className="KacharsRate CustomersRate">
          <span className="titleRate">میانگین رتبه مشتریان </span>
          <span className="ratingStar">
            <Rating ratingValue={data.rate * 20} readonly={true} />
          </span>
        </div>
      </div>
      <CommentProduct comments={data.comments} avg_rate={data.rate} />
      {/* <CommentView
          vendor_item_id={this.state.selectedVendor?.vendor_item_id}
          item_id={this.state.data.id}
          comments={comments}
          avg_rate={this.state.data.avg_rate}
          modalToggler={this.modalToggler}
        /> */}
    </div>
  ) : (
    <Spinner />
  );
};

export default VendorDetails;
